import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import './HeaderNavigationItem.scss';
import useHeaderNavigationItem from './useHeaderNavigationItem';
import { getClasses } from '@utils';

interface HeaderNavigationItemProps {
	title: string;
	path: string;
	currentTab: string;
}

const HeaderNavigationItem: FunctionComponent<HeaderNavigationItemProps> = ({ title, path, currentTab }) => {
	const { savePathHandler, isActive } = useHeaderNavigationItem(title, currentTab, path);

	return (
		<div
			onClick={savePathHandler}
			className={getClasses({
				'sidebar-menu-item__wrapper': true,
				'sidebar-menu-item__wrapper--active': isActive,
			})}
		>
			<p className="sidebar-menu-item__title">{title}</p>
		</div>
	);
};

export default memo(HeaderNavigationItem);
